export const COLLECTION_ENTRY_STORAGE_KEY = "collection_entry_path";
export const COLLECTION_PROMPT_FLAG_KEY = "collection_login_prompt_shown";

export const buildCollectionFallbackPath = () => {
	if (typeof window === "undefined") {
		return "/";
	}

	const { pathname, search, hash } = window.location;
	const composed = `${pathname || ""}${search || ""}${hash || ""}`;
	return composed.length > 0 ? composed : "/";
};

export const getStoredCollectionEntryPath = () => {
	try {
		return sessionStorage.getItem(COLLECTION_ENTRY_STORAGE_KEY);
	} catch (_) {
		return null;
	}
};

export const rememberCollectionEntryPath = (path) => {
	if (!path) return;
	try {
		sessionStorage.setItem(COLLECTION_ENTRY_STORAGE_KEY, path);
	} catch (_) {
		// storage 접근 불가 시 무시
	}
};

export const clearCollectionSessionState = () => {
	try {
		sessionStorage.removeItem(COLLECTION_ENTRY_STORAGE_KEY);
		sessionStorage.removeItem(COLLECTION_PROMPT_FLAG_KEY);
	} catch (_) {
		// noop
	}
};

export const hasCollectionPromptSeen = () => {
	try {
		return sessionStorage.getItem(COLLECTION_PROMPT_FLAG_KEY) === "true";
	} catch (_) {
		return false;
	}
};

export const markCollectionPromptSeen = () => {
	try {
		sessionStorage.setItem(COLLECTION_PROMPT_FLAG_KEY, "true");
	} catch (_) {
		// noop
	}
};

export const redirectToCollectionLogin = (loginFn, explicitPath) => {
	const fallbackPath = explicitPath || buildCollectionFallbackPath();
	const storedPath = getStoredCollectionEntryPath();
	const targetPath = storedPath || fallbackPath;

	if (!storedPath) {
		rememberCollectionEntryPath(fallbackPath);
	}

	markCollectionPromptSeen();
	loginFn(targetPath);
};
